import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {compose} from 'redux'

import { withModule } from '../redux/goose'
import MessengerModule, { onSDKReady } from '../redux/modules/messenger'
import WebviewModule from '../redux/modules/webview'

/*
 * This container handles webview embedding and is responsible for calling initialization
 * code for the various embedding contexts.
 */
class WebviewContainer extends React.PureComponent{
  static propTypes = {
    webviewContext: PropTypes.string,
    onMessengerSDKReady: PropTypes.func,
    children: PropTypes.object,
  }

  componentWillUnmount() {
    window.extAsyncInit = null
  }

  componentDidMount() {
    const { webviewContext } = this.props
    switch (webviewContext) {
      case WebviewModule.constants.MESSENGER_CONTEXT: {
        return this.onMessengerContext()
      }
      case WebviewModule.constants.APP_IOS_CONTEXT: {
        return this.onAppIOSContext()
      }
    }
  }

  onMessengerContext() {
    // If we're in a messenger context we need to inject the messenger extension kit,
    // wait for init and then mark it as ready for the rest of the application to
    // consume.
    const { onMessengerSDKReady } = this.props

    window.extAsyncInit = () => {
      // Make sure we're actually in a webview extension.
      if (window.MessengerExtensions.isInExtension()) onMessengerSDKReady()
    }

    // Inject the SDK on the page.
    (function(d, s, id){
      if (d.getElementById(id)) {return;}

      const js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.com/en_US/messenger.Extensions.js";

      const fjs = d.getElementsByTagName(s)[0];
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'Messenger'));
  }

  onAppIOSContext() {
    // noop
  }

  render(){
    const { children } = this.props
    return (
      <React.Fragment>
        { children }
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  webviewContext: WebviewModule.selectors.getContext(state),
})

const mapDispatchToProps = {
  onMessengerSDKReady : onSDKReady,
}

export default compose(
  withModule(WebviewModule),
  withModule(MessengerModule),
  connect(mapStateToProps, mapDispatchToProps)
)(WebviewContainer)



// WEBPACK FOOTER //
// ./src/Containers/WebviewContainer.js